import React from 'react';
import ArtistSelect, { ArtistSelectProps } from './ArtistSelect';

type TrackArtistSelectProps = ArtistSelectProps;

const TrackArtistSelect: React.FC<TrackArtistSelectProps> = (props) => {
    return <ArtistSelect {...props} />;
};

export default TrackArtistSelect;
